export enum HomeMatchDetailsCtaVariant {
    FAVORITES = "favorites",
    MY_INQUIRIES = "my_inquiries"
}
export enum HomeMatchDetailsCtaVariant {
    FAVORITES = "favorites",
    MY_INQUIRIES = "my_inquiries"
}
